<template>
  <div id="packs-page">
    <section class="container oversized-container my-2 content-section">
      <div class="row">
        <div class="col-12 col-title-s1">
          <h3 class="title">Paquete Movilidad</h3>
          <p>
            Selecciona alguno de nuestros paquetes Skycel para tu dispositivo movil.
          </p>
        </div>

        <offers-slider class="col-12 col-carousel" />

      </div>
    </section>
  </div>
</template>

<script>
import offersSlider from '../daniel/offers-slider.vue'
export default {
  components: { offersSlider },
}
</script>
